import React from "react"
import ReactHtmlParser from "react-html-parser"

import { graphql } from "gatsby"

import { render } from "datocms-structured-text-to-html-string"
import sanitizeHtml from "sanitize-html"

type StructuredTextContentProps = {
  data: any
  isNotRichContent?: boolean
}

const StructuredTextContent: React.FC<StructuredTextContentProps> = ({ data, isNotRichContent }) => {
  const options = {
    renderBlock({ record, adapter: { renderNode } }) {
      return renderNode("figure", {}, renderNode("img", { src: record.url }))
    },
    renderInlineRecord({ record, adapter: { renderNode } }) {
      return renderNode("a", { href: `/${record.slug}` }, record.title)
    },
    renderLinkToRecord({ record, children, adapter: { renderNode } }) {
      return renderNode("a", { href: `/${record.slug}` }, children)
    },
  }

  if (isNotRichContent) {
    return <div>{data && ReactHtmlParser(sanitizeHtml(render(data, options)))}</div>
  } else {
    return (
      <div>
        {data && data.structuredText && ReactHtmlParser(sanitizeHtml(render(data.structuredText.value, options)))}
      </div>
    )
  }
}

export const fragments = graphql`
  fragment StructuredTextFields on DatoCmsStructuredText {
    __typename
    id
    structuredText {
      value
    }
  }
`

export default StructuredTextContent
